import { Chip } from "@mui/material";
import { DriverInvoiceState } from "../interfaces/common/driver-invoices";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import VerifiedIcon from '@mui/icons-material/Verified';

export const showDriverInvoiceState = (state: DriverInvoiceState): JSX.Element => {
    switch (state) {
        case DriverInvoiceState.PENDING_PAYMENT:
            return <Chip icon={<HourglassBottomIcon />} label={"Awaiting Payment"} />
        case DriverInvoiceState.PAID:
            return <Chip icon={<VerifiedIcon />} label={"Paid"} />
    }
}